import { render, staticRenderFns } from "./ACTSf.vue?vue&type=template&id=d284447c&scoped=true"
import script from "./ACTSf.vue?vue&type=script&lang=js"
export * from "./ACTSf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d284447c",
  null
  
)

export default component.exports